export default __webpack_public_path__ + "static/media/avatar_placeholder.e2d498f8.webp";